import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Button,
  CheckIcon,
  Container,
  Group,
  Paper,
  Text,
  Title,
} from "@mantine/core";
import { useUserProvider } from "../utils/UserProvider";

function Success() {
  const navigate = useNavigate();
  const { initRevcat } = useUserProvider();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    initRevcat();
  }, []);

  useEffect(() => {
    const sessionId = searchParams.get("session_id");
    if (!sessionId) {
      navigate("/");
    }
  }, []);

  return (
    <Container size="sm" my="xl">
      <Paper shadow="" radius="md" p="xl">
        <Group justify="center" mb="md">
          <CheckIcon color="#003554" size={"md"} width={50} />
        </Group>
        <Title ta="center" mb="md">
          Purchase Successful!
        </Title>
        <Text ta={"center"}>
          Thank you for your purchase. Your transaction was successful, and your
          premium status has been activated.
        </Text>
        <Group justify="center" mt={20}>
          <Button variant="" onClick={() => navigate("/")}>
            Return Home
          </Button>
        </Group>
      </Paper>
    </Container>
  );
}

export default Success;
